import {
  ActionIcon,
  Group,
  Header,
  useMantineColorScheme,
} from '@mantine/core';
import { LuSun, LuMoonStar, LuDatabase } from 'react-icons/lu';
import {
  StyledHeaderBrand,
  StyledHeaderContent,
  StyledHeadingBlock,
  StyledHeading,
  StyledLogo,
  StyledSubheading,
} from './styles';

export const AppHeader = () => {
  const { colorScheme, toggleColorScheme } = useMantineColorScheme();
  const dark = colorScheme === 'dark';

  return (
    <Header height={64} px={'xl'}>
      <StyledHeaderContent>
        <StyledHeaderBrand>
          <StyledLogo>
            <LuDatabase size={20} />
          </StyledLogo>
          <StyledHeadingBlock>
            <StyledHeading>Administration</StyledHeading>
            <StyledSubheading>Morph Mapper</StyledSubheading>
          </StyledHeadingBlock>
        </StyledHeaderBrand>

        <Group spacing="sm">
          <ActionIcon
            variant="subtle"
            color="gray"
            size="lg"
            onClick={() => toggleColorScheme()}
            title="Toggle color scheme"
          >
            {dark ? <LuSun size={20} /> : <LuMoonStar size={20} />}
          </ActionIcon>
        </Group>
      </StyledHeaderContent>
    </Header>
  );
};
